<template>
  <div class="white-container full-page-container common-table">
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="城市">
        <el-select v-model="search.city" placeholder="城市">
          <el-option label="全国" value="" />
          <el-option v-for="item in cityList" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="教练级别">
        <el-select v-model="search.level" placeholder="选择教练级别">
          <el-option label="全部" value="" />
          <el-option v-for="item in coachLevels" :key="item.id" :label="item.level" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="合作状态">
        <el-select v-model="search.cooperateStatus" placeholder="选择合作状态">
          <el-option v-for="item in cooperateStatus" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="运动类型">
        <el-select v-model="search.exerciseType" multiple placeholder="选择运动类型">
          <el-option v-for="item in exerciseType" :key="item.id" :label="item.tagName || ''" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="教练ID">
        <el-input v-model="search.id" :maxlength="64" placeholder="填写教练ID" />
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.name" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit()">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="activity-preorder operation-bar">
      <el-button size="small" type="primary" @click="exportBtn">
        <svg-icon icon-class="batch" />
        批量导出
      </el-button>
      <div class="import-cont">
        <el-upload v-if="!importForm.importFile" ref="uploader" action="" accept="" :show-file-list="false" :auto-upload="false" :on-change="importBtn">
          <el-button size="small" type="primary">
            <svg-icon icon-class="import" />
            导入教练信息
          </el-button>
        </el-upload>
        <template v-else>
          <span class="file-txt">{{ importForm.inportName }}</span>
          <el-button size="small" type="primary" @click="commitImport">确认</el-button>
          <el-button size="small" @click="cancelImport">取消</el-button>
        </template>
        <a download class="download-file" href="javascript:void(0)" @click="getCoachTemplate">
          <i class="el-icon-document" />下载文件模板
        </a>
      </div>
    </div>
    <TableList ref="multipleTable" size="small" :table-query="search" :query-function="$Api.coach.postCoachList" :deal-data="dealData" style="width: 100%" @selection-change="selectionItemChange">
      <el-table-column type="selection" width="55" fixed />
      <el-table-column prop="id" label="教练ID" fixed />
      <el-table-column prop="id" label="头像">
        <template slot-scope="{row}">
          <img :src="row.headImgUrl" alt="" class="user-logo" style="width: 50px;height: 50px;border-radius: 50px;">
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" />
      <el-table-column prop="nickname" label="昵称" />
      <el-table-column prop="level" label="级别" width="100">
        <template slot-scope="{row}">
          <el-tag v-show="row.level === '特邀'" class="black-color" size="mini" disable-transitions>{{ row.level }}</el-tag>
          <el-tag v-show="row.level === 'Master'" class="golden-color" size="mini" disable-transitions>{{ row.level }}</el-tag>
          <el-tag v-show="row.level === 'Team'" class="red-color" size="mini" disable-transitions>{{ row.level }}</el-tag>
          <el-tag v-show="row.level === 'Member'" class="gray-color" size="mini" disable-transitions>{{ row.level }}</el-tag>
          <el-tag v-show="levels && !levels.includes(row.level)" class="gray-color" size="mini" disable-transitions>{{ row.level }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sexName" label="性别" />
      <el-table-column prop="city" label="所在城市" />
      <el-table-column prop="cooperateStatusName" label="合作状态" />
      <el-table-column prop="movementTypeName" label="运动类型" />
      <el-table-column fixed="right" width="100px" label="操作">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </TableList>
    <el-dialog class="feedback-dialog" :visible.sync="importStatus" title="导入反馈">
      <div class="txt-cont">
        <p>失败：<span class="danger-color">{{ importFeedback.uploadFailList.length }}</span>条</p>
        <div v-if="importFeedback.uploadFailList.length" class="error-cont">
          <span>详情：</span>
          <div class="error-list">
            <p v-for="(item, index) in importFeedback.uploadFailList" :key="index" class="error-li">{{ item.name }}，原因：{{ item.describe }}</p>
          </div>
        </div>
      </div>
      <div class="txt-cont">
        成功：<span class="success-color">{{ importFeedback.uploadSuccessList.length }}</span>条
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TableList from '@/components/TableList/index.vue';
import { getFileType } from '@/common/js/util';

export default {
  components: { TableList },
  data() {
    return {
      selectCoachId: [],
      cityList: [],
      exerciseType: [], // 下拉运动类型
      cooperateStatus: [
        {
          value: 0,
          label: '合作中',
        },
        {
          value: 1,
          label: '暂停合作',
        },
      ], // 下拉合作类型
      search: {
        city: '',
        level: '',
        cooperateStatus: undefined,
        exerciseType: undefined,
        id: '',
        name: '',
      },
      importForm: {
        importName: '',
        importFile: null,
      },
      importStatus: false,
      importFeedback: {
        uploadFailList: [],
        uploadSuccessList: [],
      },
    };
  },
  computed: {
    // 教练级别
    coachSelectVO() {
      return this.$store.state.activity.coachSelectVO.reduce((init, item) => {
        if (!init.includes(item.level) && item.level) init.push(item.level);
        return init;
      }, []);
    },
    // 教练级别
    coachLevels() {
      return this.$store.state.activity.coachLevels;
    },
    levels() {
      // let list = [];
      // this.$store.state.activity.coachLevels.forEach(item => {
      //   item.level && list.push(item.level);
      // });
      // list = [...new Set(list)];
      // return list;
      return ['Master', 'Team', 'Member', '特邀'];
    },
  },
  created() {
    this.getCoachSelect();
  },

  methods: {
    async getCoachTemplate() {
      await this.$Api.coach.getCoachTemplate();
    },
    getCoachSelect() {
      this.$Api.coach.getCoachSelect().then(res => {
        this.exerciseType = res.movingSelectVO || [];
        this.cityList = res.cityNames || [];
      });
    },
    edit(row) {
      this.$router.push({ path: '/coach/information/edit', query: { id: row.id } });
    },
    searchSubmit() {
      this.$refs['multipleTable'].searchAndReset();
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.$refs['multipleTable'].searchAndReset();
      });
    },
    // 当选择项发生变化时会触发该事件
    selectionItemChange(selection) {
      this.selectCoachId = selection.reduce((init, item) => {
        init.push(item.id);
        return init;
      }, []);
    },
    // 导出
    async exportBtn() {
      if (!this.selectCoachId.length) {
        this.$message.error('请选择导出的教练');
        return;
      }
      await this.$Api.coach.exportCoachList({ coachId: this.selectCoachId.join(',') });
    },
    // 导入教练信息
    importBtn(file) {
      if (getFileType(file.raw.name) !== 'excel') {
        this.$message.error('导入失败，请选择Excel文件');
        this.$refs.uploader.clearFiles();
        return;
      }
      this.importForm.importFile = file.raw;
      this.importForm.inportName = file.raw.name;
    },
    commitImport() {
      this.$Api.coach.postUploadCoach({
        file: this.importForm.importFile,
      }).then(res => {
        this.importFeedback = Object.assign(this.importFeedback, res);
        this.importStatus = true;
        this.cancelImport();
        this.$nextTick(() => {
          this.$refs['multipleTable'].searchAndReset();
        });
      }).catch(() => {
        this.cancelImport();
      });
    },
    cancelImport() {
      this.importForm = this.$options.data.call(this).importForm;
    },
    dealData(data) {
      return data.map((item) => {
        item.cooperateStatusName = item.cooperateStatus === 1 ? '暂停合作' : '合作中';
        item.movementTypeName = item.movementTypeSelectVOS.reduce((init, it) => {
          init.push(it.tagName);
          return init;
        }, []).join('/');
        item.sexName = {
          0: '未知',
          1: '男',
          2: '女',
        }[item.sex];
        return item;
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.feedback-dialog {
  .txt-cont {
    margin-bottom: 12px;
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    color: #494949;
    .success-color {
      color: #67c23a;
    }
    .danger-color {
      color: #f56c6c;
    }
  }
  .error-cont {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    .error-list {
      flex: 1;
      width: 100%;
    }
  }
}
.golden-color,
.red-color,
.black-color {
  display: inline-block;
  min-width: 80px;
  height: auto;
  text-align: center;
  line-height: 22px;
}
.gray-color {
  border: 0;
  padding: 1px 13px;
  background: rgba(155, 155, 155, 1);
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
}
.golden-color {
  border: 0;
  padding: 1px 13px;
  background: rgba(202, 166, 112, 1);
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
}
.red-color {
  border: 0;
  padding: 1px 13px;
  background: rgba(220, 0, 25, 1);
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
}
.black-color {
  border: 0;
  padding: 1px 13px;
  background: rgba(0, 0, 0, 1);
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
}
.import-cont {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 30px;
  /deep/.el-upload:focus {
    color: #fff;
  }
  .file-txt {
    margin-right: 15px;
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-decoration-line: underline;
    color: #0085d0;
  }
}
.download-file {
  margin-left: 32px;
  font-family: "Noto Sans SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #0085d0 !important;
  cursor: pointer;
  text-decoration: none !important;
  .el-icon-document {
    margin-right: 7px;
  }
}
</style>
